import { Component, Input, OnInit } from '@angular/core';
import { GridCell } from '../../../models/sections-model';

@Component({
  selector: 'kw-product-share',
  templateUrl: './product-share.component.html',
  styleUrls: ['./product-share.component.scss']
})
export class ProductShareComponent implements OnInit {
  @Input() gridCell:GridCell
  
  constructor() { }

  ngOnInit(): void {
  }

}
